import Dexie, { EntityTable } from 'dexie';

import { LangEntity } from './lang';

const initializeDB = () => {
  const db = new Dexie('AppDB') as Dexie & {
    lang: EntityTable<LangEntity, 'id'>;
  };

  db.version(1).stores({
    lang: '++id, currentLang',
  });

  return db;
};

export const appDB = initializeDB();

export type AppDB = typeof appDB;
